
export const CRICKET_GAME = "cricket";
export const CRICKET_CUT_GAME = "cricket-cut";
export const CRICKET_SCORES = [25, 20, 19, 18, 17, 16, 15];

export const GAMES_TYPE = [
  { label: 301, value: "301" },
  { label: 501, value: "501" },
  { label: 701, value: "701" },
  { label: "Cricket", value: CRICKET_GAME },
  { label: "Cricket Cut Throatch", value: CRICKET_CUT_GAME },
];


export const getCurrentIndexGame = (currentGameId) => {
  return GAMES_TYPE.findIndex(
    (props) => props.value === currentGameId
  );
}

export const getCurrentGame = (currentGameId) => {
  return GAMES_TYPE.find(
    (props) => props.value === currentGameId
  );
}

export const initScore = (currentGameId) => {
  let game = getCurrentGame(currentGameId);
  return (typeof game.label === 'number') ? game.label : 0;
}

export const isCricketGame = (gameType) => {
  return [CRICKET_GAME, CRICKET_CUT_GAME].includes(gameType);
}